import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7cb3df7a")

_pushScopeId("data-v-7cb3df7a")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "list-item" }
const _hoisted_3 = { class: "p-mr-2" }
const _hoisted_4 = { class: "list-detail p-d-flex p-ai-center p-text-truncate" }
const _hoisted_5 = { class: "p-mr-2 p-text-truncate" }
const _hoisted_6 = { class: "name p-text-truncate" }
const _hoisted_7 = { class: "description p-d-flex p-ai-center" }
const _hoisted_8 = { class: "p-text-bold" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ExperimentTag = _resolveComponent("ExperimentTag")!
  const _component_ExperimentStatus = _resolveComponent("ExperimentStatus")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("i", {
          class: `bx-sm ${_ctx.getExperimentIcon(_ctx.type)}  p-primary item-icon`
        }, null, 2)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _withDirectives(_createVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.name), 1)
          ], 512), [
            [
              _directive_tooltip,
              _ctx.name,
              void 0,
              { top: true }
            ]
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_ExperimentTag, { name: _ctx.type }, null, 8, ["name"]),
            _createVNode("div", null, [
              _withDirectives(_createVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$moment(_ctx.createdDate).fromNow() + _ctx.$t("label.by")), 1)
              ], 512), [
                [
                  _directive_tooltip,
                  _ctx.$moment(_ctx.createdDate).format('LLLL'),
                  void 0,
                  { top: true }
                ]
              ]),
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.getFullname(_ctx.createdBy)), 1)
            ])
          ])
        ])
      ]),
      (_ctx.type !== 'FOLDER')
        ? (_openBlock(), _createBlock(_component_ExperimentStatus, {
            key: 0,
            status: _ctx.status
          }, null, 8, ["status"]))
        : _createCommentVNode("", true)
    ])
  ]))
})